import { Switch } from "antd";
import styled from "styled-components";

export const RASwitch = ({ checked = false, onChange, "data-testid": dataTestId = null }) => (
	<Wrapper>
		<Switch checked={checked} onChange={onChange} data-testid={dataTestId} />
	</Wrapper>
);

const Wrapper = styled.div`
	.ant-switch.ant-switch-checked {
		background: rgba(255, 177, 26, 0.2) !important;
	}
	.ant-switch.ant-switch-checked .ant-switch-handle::before {
		background: #ffb11a !important;
	}
	.ant-switch .ant-switch-handle::before {
		box-shadow: none;
	}
`;
